import { useEffect } from "react";
import BlogListInner from "../components/BlogListInner";
import Breadcrumb from "../components/Breadcrumb";
import FooterThree from "../components/FooterThree";
import HeaderOne from "../components/HeaderOne";
import { useLoader } from "../context/LoaderContext";
import { useSchoolDetailsContext } from "../context/SchoolDetailsContext";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";
import { fetchSchoolDetails } from "../api/SchoolDetailsApi";
import { useAllDataContext } from "../context/AllDataContext";
import { FetchAllApi } from "../components/FetchAllApi";
import { useLocation } from "react-router-dom";

const BlogListPage = () => {
  const { schoolDetailsData, setSchoolDetailsData } = useSchoolDetailsContext();
  const { setLoading } = useLoader();
  const location = useLocation();

  useEffect(() => {
    const section = location.state?.section;
    if (section) {
      const el = document.getElementById(section.toLowerCase());
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.state]);
  const { allData, setAllData } = useAllDataContext();
  // const [activitiesData, setActivitiesData] = useState([]);
  const activitiesData = allData.activitiesData;
  const activitiesBannerData = allData.allBannerData[0]?.activities_title;
  // useEffect(() => {
  //   setLoading(true);
  //   Promise.all([fetchActivitiesList()])
  //     .then(([activities]) => {
  //       setActivitiesData(activities);
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 500);
  //     })
  //     .catch(() => {
  //       console.error("Server Error");
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 500);
  //     });
  // }, [setLoading]);
  FetchAllApi({ schoolDetailsData, setAllData, setLoading });

  useEffect(() => {
    if (schoolDetailsData.length === 0) {
      Promise.all([fetchSchoolDetails()])
        .then(([schoolDetailsData]) => {
          setSchoolDetailsData(schoolDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [schoolDetailsData.length, setSchoolDetailsData]);
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderOne */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb
        heading={activitiesBannerData}
        title={"Student Life"}
        subTitle={"Activities"}
      />

      {/* BlogListInner */}
      <BlogListInner studentLifeData={activitiesData} />

      {/* CertificateOne */}
      {/* <CertificateOne /> */}

      {/* FooterOne */}
      <FooterThree />
    </>
  );
};

export default BlogListPage;
